import { AxiosError, AxiosHeaders, AxiosRequestConfig, AxiosResponse } from "axios";
import { axiosInstance } from "../../../api/axiosInstance";
import { EASY_EDU_SERVER_BASE_URL } from "../../../environment";
import { openReceiptPrint } from "../../../features/fees/receipt/receiptPrint";
import { APIS, DASHBOARD_APIS, STUDENT_APIS } from "../api/apis";
import { getLoginId, isUserLoggedIn } from "../user/UserService";
import { Dashboard, Fee, FeeDue, Grade, Section, Student } from "./types";

export function getInitialDashboardData(): Dashboard {
  return {
    totalStudents: 0,
    activeStudents: undefined,
    inActiveStudents: undefined,
    totalFeeDues: 0,
    totalFeesCollected: 0,
    totalDiscountGiven: 0,
    dailyFeeCollection: [],
    monthlyFeeCollection: [],
    feesAndDuesByGrade: [],
    academicYear: "",
    previousTotalDue: 0,
    absenteesByGrade: [{ grade: undefined, sections: [{ name: undefined, total: undefined }] }],
    totalFailedAbsentMessages: 0,
    smsWalletBalance: undefined,
    facultyAbsenteesByDept: undefined,
    activeAdmissions: undefined
  };
}
export function getFeeInitialData(): Fee {
  return {
    studentName: "",
    admissionNo: "",
    gradeName: "",
    sectionName: "",
    amount: 0,
    transactionId: "",
    dateOfPayment: "",
    paymentMode: "CASH",
    discount: 0,
    terms: "",
    receiptNo: undefined,
    payable: 0,
    balance: 0,
    collectedBy: "",
    gradeTerm: undefined,
    previousYDiscount: undefined,
    currentYDiscount: undefined,
    previousYearDues: undefined,
  };
}
export function getFeeDueInitialData(): FeeDue {
  return {
    studentName: "",
    admissionNo: "",
    guardianPhoneNo: 0,
    gradeName: "PRE-KG",
    sectionName: "A",
    terms: "",
    payable: 0,
    academicYear: "",
    previousTotalDue: 0,
    paymentOrderInProgress: false,
    paymentLink: undefined,
  };
}

export function getAxiosHeaders(): AxiosHeaders {
  let headers: AxiosHeaders = new AxiosHeaders();
  headers.setContentType("application/json");
  if (isUserLoggedIn()) headers.set("loginId", getLoginId());
  return headers;
}

export async function getInActiveStudentsBy(grade: string): Promise<Student[]> {
  console.log(">>> AxiosAPI::getInActiveStudentsBy");

  let students: Student[] = [];

  try {
    let url = STUDENT_APIS.GET_IN_ACTIVE_STUDENTS_BY_GRADE.replace("grade_value", grade).replace("status_val", "false");

    console.log("Final URL : " + url);
    let currHeaders: AxiosHeaders = getAxiosHeaders();
    await axiosInstance
      .get(EASY_EDU_SERVER_BASE_URL + url, { headers: currHeaders })
      .then((res) => {
        let data = res.data;

        if (data !== undefined && data !== null && data.length > 0) {
          students = data;
        } else {
          alert("No results for the query. Try with differerent options");
          console.log(data);
        }
      })
      .catch((error) => {
        alert("In FeeDue get response error block" + error.message);
        console.log(error);
      });
  } catch (e) {
    console.log(e);
  }

  return students;
}

export async function getStudentsBy(grade: string, section: string, status: string): Promise<Student[]> {
  console.log(">>> AxiosAPI::getActiveStudentsBy");

  let students: Student[] = [];

  try {
    let url = undefined;
    if (status !== undefined) {
      url = STUDENT_APIS.GET_STUDENTS_BY_GRADE_AND_SECTION_AND_STATUS.replace("grade_value", grade)
        .replace("section_value", section)
        .replace("status_val", status);
    } else {
      url = STUDENT_APIS.GET_ALL_STUDENTS_FOR_GRADE_AND_SECTION.replace("grade_value", grade).replace("section_value", section);
    }
    console.log("Final URL : " + url);
    let currHeaders: AxiosHeaders = getAxiosHeaders();
    await axiosInstance
      .get(EASY_EDU_SERVER_BASE_URL + url, { headers: currHeaders })
      .then((res) => {
        let data = res.data;

        if (data !== undefined && data !== null && data.length > 0) {
          students = data;
        } else {
          alert("No results for the query. Try with differerent options");
          console.log(data);
        }
      })
      .catch((error) => {
        alert("In FeeDue get response error block" + error.message);
        console.log(error);
      });
  } catch (e) {
    console.log(e);
  }

  return students;
}

export async function getSections(): Promise<Section[]> {
  console.log(">>> getSections");
  let sections: Section[] = [];

  const currHeaders = getAxiosHeaders();

  await axiosInstance
    .get(EASY_EDU_SERVER_BASE_URL + APIS.SECTIONS, { headers: currHeaders })
    .then((res: AxiosResponse) => {
      sections = res.data;
    })
    .catch((error) => {
      console.log(error);
    });

  return sections;
}

export async function getGrades(): Promise<Grade[]> {
  console.log(">>> getGrades");
  let grades: Grade[] = [];

  const currHeaders = getAxiosHeaders();

  await axiosInstance
    .get(EASY_EDU_SERVER_BASE_URL + APIS.GRADES, { headers: currHeaders })
    .then((res: AxiosResponse) => {
      grades = res.data;
    })
    .catch((error) => {
      console.log(error);
    });

  return grades;
}

export async function getFacultyDashboardData(): Promise<Dashboard> {
  console.log(">>> AxiosAPI::getFacultyDashboardData");

  let dashboard: Dashboard = getInitialDashboardData();

  try {
    let url = DASHBOARD_APIS.GET_FACULTY_DASHBOARD;

    console.log("Final URL : " + url);
    let currHeaders: AxiosHeaders = getAxiosHeaders();
    await axiosInstance
      .get(EASY_EDU_SERVER_BASE_URL + url, { headers: currHeaders })
      .then((res) => {
        let data = res.data;
        if (data !== undefined && data !== null) {
          dashboard = data;
        } else {
          alert("No results for the query. Try with differerent options");
          console.log(data);
        }
      })
      .catch((error) => {
        alert("In FeeDue get response error block" + error.message);
        console.log(error);
      });
  } catch (e) {
    console.log(e);
  }

  return dashboard;
}

export async function getDashboardData(): Promise<Dashboard> {
  console.log(">>> AxiosAPI::getDashboardData");

  let dashboard: Dashboard = getInitialDashboardData();

  try {
    let url = DASHBOARD_APIS.GET_DASHBOARD;

    console.log("Final URL : " + url);
    let currHeaders: AxiosHeaders = getAxiosHeaders();
    await axiosInstance
      .get(EASY_EDU_SERVER_BASE_URL + url, { headers: currHeaders })
      .then((res) => {
        let data = res.data;

        if (data !== undefined && data !== null) {
          dashboard = data;
        } else {
          alert("No results for the query. Try with differerent options");
          console.log(data);
        }
      })
      .catch((error) => {
        alert("In FeeDue get response error block" + error.message);
        console.log(error);
      });
  } catch (e) {
    console.log(e);
  }

  return dashboard;
}

// The backend works out who may see the receipt from the login; no student/grade headers needed.
// Asks Classic (server PDF) or New (browser PDF) - see features/fees/receipt/ReceiptPrintHost
export const printReceipt = (receiptNo: number) => {
  openReceiptPrint(receiptNo, (no) => printPDF(APIS.FEE_RECEIPT_PDF.replace("receipt_no", no.toString()), getAxiosHeaders()));
};

export const printPDF = (url: string, headers: AxiosHeaders) => {
  if (headers === null) {
    headers = getAxiosHeaders();
  }
  axiosInstance
    .get(EASY_EDU_SERVER_BASE_URL + url, {
      headers: headers,
      responseType: "blob",
    })
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "file.pdf"); //or any other extension
      document.body.appendChild(link);
      link.click();
    })
    .catch((error: AxiosError) => {
      console.log("Going to call pdf endpoint: " + error);
      console.log(error);
      if (error.response?.status === 401) {
        console.log("Error code: " + error.response?.status);
      }
      alert(error.response?.data);
    });
};

//FeeDue APIs
export async function getFeeDuesByStudent(admissionNo: string): Promise<FeeDue[]> {
  console.log(">>> AxiosAPI::getFeeDuesByStudent");

  let feeDueList: FeeDue[] = [];

  try {
    let url = APIS.FEE_DUE_DATA_FOR_STUDENT_BY_ADMISSION_NO;

    console.log("Final URL : " + url);

    let currHeaders: AxiosHeaders = getAxiosHeaders();
    currHeaders.set("admissionNo", admissionNo);
    await axiosInstance
      .get(EASY_EDU_SERVER_BASE_URL + url, { headers: currHeaders })
      .then((res) => {
        let data = res.data;

        if (data.length > 0) {
          feeDueList = data;
        } else {
          alert("No fee dues for admission No: " + admissionNo);
          console.log(data);
        }
      })
      .catch((error) => {
        alert("In FeeDue get response error block" + error.message);
        console.log(error);
      });
  } catch (e) {
    console.log(e);
  }

  return feeDueList;
}

// Faculty APIs

//Generic GET, PUT
export const get = (relativeURL: string, headers: AxiosHeaders | null): Promise<AxiosResponse> => {
  if (headers == null) {
    headers = getAxiosHeaders();
  }
  let response: Promise<AxiosResponse> = axiosInstance.get(EASY_EDU_SERVER_BASE_URL + relativeURL, {
    headers: headers,
  });
  return response;
};

export const post = async <T,>(relativeURL: string, headers: AxiosHeaders | null, data: T): Promise<AxiosResponse> => {
  if (headers === null) {
    headers = getAxiosHeaders();
  }
  let response: Promise<AxiosResponse> = axiosInstance.post(EASY_EDU_SERVER_BASE_URL + relativeURL, data, {
    headers: headers,
  });
  return response;
};

export const postMultipart = async <T,>(relativeURL: string, headers: AxiosHeaders | null, data: T): Promise<AxiosResponse> => {

  let response: Promise<AxiosResponse> = axiosInstance.post(EASY_EDU_SERVER_BASE_URL + relativeURL, data);
  return response;
};

export const postForBlob = async <T,>(relativeURL: string, headers: AxiosHeaders | null, data: T): Promise<AxiosResponse> => {
  if (headers === null) {
    headers = getAxiosHeaders();
  }
  let response: Promise<AxiosResponse> = axiosInstance.post(EASY_EDU_SERVER_BASE_URL + relativeURL, data, {
    responseType: "blob"
  });
  return response;
};

export const patch = async <T,>(relativeURL: string, headers: AxiosHeaders | null, data: T | null): Promise<AxiosResponse> => {
  if (headers === null) {
    headers = getAxiosHeaders();
  }
  let response: Promise<AxiosResponse> = axiosInstance.patch(EASY_EDU_SERVER_BASE_URL + relativeURL, data, {
    headers: headers,
  });
  return response;
};

export const patchWOHeaders = async <T,>(relativeURL: string, data: T | null): Promise<AxiosResponse> => {
  let response: Promise<AxiosResponse> = axiosInstance.patch(EASY_EDU_SERVER_BASE_URL + relativeURL, data);
  return response;
};

export const deleteOperation = async <T,>(relativeURL: string, config: AxiosRequestConfig): Promise<AxiosResponse> => {
  let response: Promise<AxiosResponse> = axiosInstance.delete(EASY_EDU_SERVER_BASE_URL + relativeURL, config);
  return response;
};
